import React, { FC, useMemo } from 'react';
import CommentsTextEditor from 'app/modules/posts/modules/post/components/postCommunication/comments/CommentsTextEditor';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import { PostCommunicationContent } from 'app/modules/posts/modules/post/components/postCommunication/types/postCommunicationContent';
import { ApprovalThreadType } from '../../types';

type Props = {
  thread: ApprovalThreadType;
};

const ApprovalCommentInput: FC<Props> = ({ thread }) => {
  const threadType = useMemo(() => {
    switch (thread) {
      case 'internal':
        return PostCommunicationContent.INTERNAL;
      case 'client':
        return PostCommunicationContent.CLIENT;
      default:
        return PostCommunicationContent.INTERNAL;
    }
  }, [thread]);

  const permissionScope = useMemo(
    () =>
      threadType === PostCommunicationContent.INTERNAL
        ? UserPermission.POST_COMMUNICATION_INTERNAL_CREATE
        : UserPermission.POST_COMMUNICATION_CLIENT_CREATE,
    [threadType],
  );

  return (
    <div className="tw-border-t tw-border-grayscale-10 tw-p-3">
      <UserPermissionGate scopes={permissionScope}>
        <CommentsTextEditor />
      </UserPermissionGate>
    </div>
  );
};

export default ApprovalCommentInput;
